import { api } from '../../client';

export interface EmployeeTaskDto {
  id: string;
  title: string;
  sort_order: number;
  project_id?: string | null;
  project_name?: string | null;
}

export interface EmployeeTaskColumnDto {
  id: string;
  title: string;
  sort_order: number;
  tasks: EmployeeTaskDto[];
}

export const employeeTaskTrackerApi = {
  async list(): Promise<{ data?: EmployeeTaskColumnDto[]; message?: string }> {
    return api.get('/employee/task-tracker') as Promise<{ data: EmployeeTaskColumnDto[] }>;
  },

  async createColumn(data: {
    title: string;
    sort_order?: number;
  }): Promise<{ data?: EmployeeTaskColumnDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/employee/task-tracker/columns', data) as Promise<{
      data: EmployeeTaskColumnDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async updateColumn(
    columnId: string,
    data: { title?: string; sort_order?: number }
  ): Promise<{ data?: EmployeeTaskColumnDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/employee/task-tracker/columns/${columnId}`, data) as Promise<{
      data: EmployeeTaskColumnDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async deleteColumn(columnId: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/employee/task-tracker/columns/${columnId}`) as Promise<{
      success?: boolean;
      message?: string;
    }>;
  },

  async reorderColumns(columnIds: string[]): Promise<{ message?: string }> {
    return api.post('/employee/task-tracker/columns/reorder', { column_ids: columnIds }) as Promise<{
      message?: string;
    }>;
  },

  async createTask(data: {
    column_id: string;
    title: string;
    sort_order?: number;
  }): Promise<{ data?: EmployeeTaskDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/employee/task-tracker/items', data) as Promise<{
      data: EmployeeTaskDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async updateTask(
    itemId: string,
    data: { column_id?: string; title?: string; sort_order?: number }
  ): Promise<{ data?: EmployeeTaskDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/employee/task-tracker/items/${itemId}`, data) as Promise<{
      data: EmployeeTaskDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async deleteTask(itemId: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/employee/task-tracker/items/${itemId}`) as Promise<{
      success?: boolean;
      message?: string;
    }>;
  },

  /**
   * List project tasks completed for this employee (in Completed column).
   */
  async listCompleted(): Promise<{
    data?: { id: string; title: string; project_name: string | null; sprint_name: string | null; completed_at: string | null }[];
    message?: string;
  }> {
    return api.get('/employee/task-tracker/completed') as Promise<{
      data: { id: string; title: string; project_name: string | null; sprint_name: string | null; completed_at: string | null }[];
    }>;
  },
};
